import MotoristaEmailService from "@/services/MotoristaEmailService";

export const motoristaEmail = {
  namespaced: true,
  state: {
    motoristaEmail: {},
  },
  actions: {
    getMotoristaEmail({ commit }, payload) {
      return MotoristaEmailService.GetMotoristaEmail(payload).then(
        (motoristaEmail) => {
          return Promise.resolve(motoristaEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    postMotoristaEmail({ commit }, payload) {
      return MotoristaEmailService.PostMotoristaEmail(payload).then(
        (motoristaEmail) => {
          return Promise.resolve(motoristaEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    putMotoristaEmail({ commit }, payload) {
      return MotoristaEmailService.PutMotoristaEmail(payload).then(
        (motoristaEmail) => {
          return Promise.resolve(motoristaEmail);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    deleteMotoristaEmail({ commit }, payload) {
      return MotoristaEmailService.DeleteMotoristaEmail(payload).then(
        (response) => {
          return Promise.resolve(response);
        },
        (error) => {
          return Promise.reject(error.response.data);
        }
      );
    },
    getMotoristaEmailOData({ commit }, payload) {
      return MotoristaEmailService.GetMotoristaEmailOData(payload).then(
        (motoristaEmail) => {
          return Promise.resolve(motoristaEmail);
        },
        (error) => {
          return Promise.reject(error);
        }
      );
    },
  },
  mutations: {},
};

export default motoristaEmail;
